import MuiLink from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';

const useStyles = makeStyles({
  linkContainer: {
    '&:hover': {
      cursor: 'pointer',
    },
    alignItems: 'center',
    display: 'inline-flex',
  },
});

type MuiLinkProps = React.ComponentProps<typeof MuiLink>;

export interface LinkProps {
  className?: string;
  color: MuiLinkProps['color'];
  href: MuiLinkProps['href'];
}

export const Link: FC<PropsWithChildren<LinkProps>> = ({ children, className, ...props }) => {
  const classes = useStyles();
  return (
    <MuiLink className={classNames(classes.linkContainer, className)} {...props} noWrap>
      {children}
    </MuiLink>
  );
};
